const templateUrl = require('./unsent-shipment-body.html');

const app = angular.module('msi.shipments.unsentShipmentBody', []);

app.component('ogUnsentShipmentBody', {
  bindings: {
    shipment: '<ogFor'
  },
  templateUrl: templateUrl
});

module.exports = app.name;
